import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const tableHeaderStyle = {
  backgroundColor: "#f1f5f9",
  color: "#334155",
  fontWeight: 600,
  fontSize: "13px",
  padding: "10px 12px",
};

const FOLIOS_WITHOUT_UCC = [
  {
    id: 1,
    folio: "477467821363",
    scheme: "Nippon India Multi Cap Fund (G)",
    name: "AMOL NAVINCHANDRA PATEL",
    pan: "AMKPP3256B",
    taxStatus: "Individual",
    holding: "SI",
    joint1: "",
    joint2: "",
  },
  {
    id: 2,
    folio: "57737843576",
    scheme: "LIC MF Consumption Fund Reg (G)",
    name: "CHAITANYA GAURISHANKAR JOSHI",
    pan: "ACTPJ9766H",
    taxStatus: "Individual",
    holding: "SI",
    joint1: "",
    joint2: "",
  },
  {
    id: 3,
    folio: "18948743",
    scheme: "Parag Parikh Flexi Cap Fund Reg (G)",
    name: "CHINTAN NAYAN BHAI RAJYAGURU",
    pan: "AZRPR1657A",
    taxStatus: "Individual",
    holding: "SI",
    joint1: "",
    joint2: "",
  },
  {
    id: 4,
    folio: "41858152/95",
    scheme: "ICICI Pru Focused Equity Fund Reg (G)",
    name: "CHINTAN NAYAN BHAI RAJYAGURU",
    pan: "AZRPR1657A",
    taxStatus: "Individual",
    holding: "SI",
    joint1: "",
    joint2: "",
  },
  {
    id: 5,
    folio: "477454379994",
    scheme: "Nippon India Multi Cap Fund (G)",
    name: "CHINTAN NAYAN BHAI RAJYAGURU",
    pan: "AZRPR1657A",
    taxStatus: "Individual",
    holding: "SI",
    joint1: "",
    joint2: "",
  },
];

const UCC_COLUMNS = [
  "Select",
  "ARN",
  "UCC",
  "Name",
  "PAN",
  "Tax Status",
  "Holding",
  "Joint 1 Name /PAN",
  "Joint 2 Name /PAN",
  "Guardian Name/ PAN",
  "UCC Type",
];

const FOLIO_COLUMNS = [
  "Select",
  "Folio",
  "Scheme",
  "Name",
  "PAN",
  "Tax Status",
  "Holding",
  "Joint 1 Name /PAN",
  "Joint 2 Name /PAN",
];

export default function RejectedUccMapping() {
  const [selectedUccIds, setSelectedUccIds] = useState([]);
  const [selectedFolioIds, setSelectedFolioIds] = useState([]);

  const toggleUccSelect = (id) => {
    setSelectedUccIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const toggleFolioSelect = (id) => {
    setSelectedFolioIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const toggleAllFolios = (checked) => {
    if (checked) setSelectedFolioIds(FOLIOS_WITHOUT_UCC.map((r) => r.id));
    else setSelectedFolioIds([]);
  };

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Rejected UCC Mapping</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/invest-bse/profile-list">Invest Online BSE</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Rejected UCC Mapping
                </li>
              </ol>
            </nav>
          </div>

          {/* Panel 1: List of unmapped UCC */}
          <div style={cardStyle}>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
              <h6 style={{ margin: 0, fontWeight: 700, color: "#334155", fontSize: "15px" }}>
                List of unmapped UCC (Select Ucc to map)
              </h6>
              <button
                type="button"
                style={{
                  background: "#10b981",
                  color: "#fff",
                  border: "none",
                  padding: "8px 16px",
                  borderRadius: "6px",
                  fontWeight: 600,
                  fontSize: "14px",
                  cursor: "pointer",
                }}
              >
                Create Client
              </button>
            </div>
            <div style={{ overflowX: "auto" }}>
              <table className="table table-bordered mb-0" style={{ fontSize: "13px" }}>
                <thead>
                  <tr>
                    {UCC_COLUMNS.map((col, i) => (
                      <th key={col} style={tableHeaderStyle}>
                        {col === "UCC" || col === "Name" || col === "PAN" ? (
                          <>
                            {col}
                            <i className="fa fa-search ms-1" style={{ fontSize: "11px", color: "#94a3b8" }} />
                          </>
                        ) : col === "Select" ? (
                          <input type="checkbox" aria-label="Select all" />
                        ) : (
                          col
                        )}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={UCC_COLUMNS.length} style={{ textAlign: "center", padding: "24px", color: "#ea580c", fontSize: "14px" }}>
                      <span className="me-2" aria-hidden>⚠</span>
                      No data available.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Panel 2: List of Folios without UCC */}
          <div style={cardStyle}>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
              <h6 style={{ margin: 0, fontWeight: 700, color: "#334155", fontSize: "15px" }}>
                List of Folios without UCC (Select Folio to map UCC)
              </h6>
              <button
                type="button"
                style={{
                  background: "#10b981",
                  color: "#fff",
                  border: "none",
                  padding: "8px 16px",
                  borderRadius: "6px",
                  fontWeight: 600,
                  fontSize: "14px",
                  cursor: "pointer",
                }}
              >
                Map & Import
              </button>
            </div>
            <div style={{ overflowX: "auto" }}>
              <table className="table table-bordered mb-0 table-striped" style={{ fontSize: "13px" }}>
                <thead>
                  <tr>
                    {FOLIO_COLUMNS.map((col) => (
                      <th key={col} style={tableHeaderStyle}>
                        {col === "Folio" || col === "Scheme" || col === "Name" || col === "PAN" ? (
                          <>
                            {col}
                            <i className="fa fa-search ms-1" style={{ fontSize: "11px", color: "#94a3b8" }} />
                          </>
                        ) : col === "Select" ? (
                          <input
                            type="checkbox"
                            aria-label="Select all"
                            checked={selectedFolioIds.length === FOLIOS_WITHOUT_UCC.length}
                            onChange={(e) => toggleAllFolios(e.target.checked)}
                          />
                        ) : (
                          col
                        )}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {FOLIOS_WITHOUT_UCC.map((row) => (
                    <tr key={row.id}>
                      <td style={{ padding: "10px 12px" }}>
                        <input
                          type="checkbox"
                          checked={selectedFolioIds.includes(row.id)}
                          onChange={() => toggleFolioSelect(row.id)}
                          aria-label={`Select row ${row.id}`}
                        />
                      </td>
                      <td style={{ padding: "10px 12px" }}>{row.folio}</td>
                      <td style={{ padding: "10px 12px" }}>{row.scheme}</td>
                      <td style={{ padding: "10px 12px" }}>{row.name}</td>
                      <td style={{ padding: "10px 12px" }}>{row.pan}</td>
                      <td style={{ padding: "10px 12px" }}>{row.taxStatus}</td>
                      <td style={{ padding: "10px 12px" }}>{row.holding}</td>
                      <td style={{ padding: "10px 12px", color: "#94a3b8" }}>{row.joint1 || "-"}</td>
                      <td style={{ padding: "10px 12px", color: "#94a3b8" }}>{row.joint2 || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
